import * as Turbo from '@hotwired/turbo';

// The FAQ search box offers article suggestions as you type. It used to ask
// for `text/javascript` and `eval()` the response; it asks for a stream now
// and hands it to Turbo, which puts the suggestions in place itself.
const searchInput = document.getElementById('zendesk_search_searchterm');
const searchForm = document.getElementById('new_zendesk_search');

const clearSuggestions = () => {
  const suggestionBox = document.getElementById('zendesk_suggestions');
  if (suggestionBox) suggestionBox.innerHTML = '';
};

const fetchSuggestions = searchterm => {
  const body = new FormData();
  body.append('searchterm', searchterm);

  return fetch(searchForm.action.replace(/search/gi, 'suggestions'), {
    method: 'POST',
    body,
    headers: { Accept: 'text/vnd.turbo-stream.html' },
  })
    .then(response => (response.ok ? response.text() : null))
    .then(stream => {
      if (stream) Turbo.renderStreamMessage(stream);
    })
    .catch(() => {
      // A failed suggestion lookup is not worth telling anyone about.
    });
};

if (searchInput && searchForm) {
  searchInput.addEventListener('input', function onInput() {
    if (this.value.length >= 3) {
      fetchSuggestions(this.value);
    } else {
      clearSuggestions();
    }
  });
}
